import React from 'react'
import { Control, Controller, FieldErrors } from 'react-hook-form'
import { t } from 'ttag'
import { CHALLENGE_ADMIN_STEP_DETAILS, FormData } from '../../ChallengeAdmin'

import YumField from '../../../../components/YumInput/YumInput'

import { ReactComponent as TitleActiveIcon } from '../../../../assets/v3/icons/title-active.svg'
import { ReactComponent as TitleInactiveIcon } from '../../../../assets/v3/icons/title-inactive.svg'
import { ReactComponent as PrizeActiveIcon } from '../../../../assets/v3/icons/prize-active.svg'
import { ReactComponent as PrizeInactiveIcon } from '../../../../assets/v3/icons/prize-inactive.svg'
import { ReactComponent as DescriptionActiveIcon } from '../../../../assets/v3/icons/description-active.svg'
import { ReactComponent as DescriptionInactiveIcon } from '../../../../assets/v3/icons/description-inactive.svg'

interface ChallengeStepPeriodProps {
  control: Control<FormData>
  errors: FieldErrors<FormData>
  formStep: number
}

export default function ChallengeStepDetails(props: ChallengeStepPeriodProps) {
  const { control, errors, formStep } = props

  const challengeNameField = (
    <Controller
      name="title"
      rules={{ required: formStep === CHALLENGE_ADMIN_STEP_DETAILS }}
      control={control}
      render={({ field: { ref, ...otherField } }) => (
        <YumField
          label={t`Challenge name (required)`}
          error={!!errors.title}
          startIcon={TitleInactiveIcon}
          /*startIcon={TitleActiveIcon}
          startIconInactive={TitleInactiveIcon}*/
          {...otherField}
          value={otherField.value ?? ''}
          inputProps={{
            autoComplete: 'off',
          }}
        />
      )}
    />
  )

  const prizeField = (
    <Controller
      name="prize"
      control={control}
      render={({ field: { ref, ...otherField } }) => (
        <YumField
          label={t`Prize`}
          error={!!errors.prize}
          startIcon={PrizeInactiveIcon}
          /*startIcon={PrizeActiveIcon}
          startIconInactive={PrizeInactiveIcon}*/
          multiline
          minRows={2}
          {...otherField}
          value={otherField.value ?? ''}
        />
      )}
    />
  )

  const descriptionField = (
    <Controller
      name="description"
      control={control}
      render={({ field: { ref, ...otherField } }) => (
        <YumField
          label={t`Description`}
          error={!!errors.description}
          startIcon={DescriptionInactiveIcon}
          /*startIcon={DescriptionActiveIcon}
          startIconInactive={DescriptionInactiveIcon}*/
          multiline
          minRows={2}
          {...otherField}
          value={otherField.value ?? ''}
        />
      )}
    />
  )

  return (
    <>
      {challengeNameField}
      {prizeField}
      {descriptionField}
    </>
  )
}
